export const showAnalytics = process.env.REACT_APP_SHOW_ANALYTICS === 'true';

export const showHistory = process.env.REACT_APP_SHOW_HISTORY === 'true';

export const loginEnabled = process.env.REACT_APP_LOGIN_ENABLED === 'true';

export const showExchangeKeys = loginEnabled && process.env.REACT_APP_SHOW_EXCHANGE_KEYS === 'true';
